import axios from "../libs/axios";

export const registerUser = ({ ...newUser }) =>
  axios.post(`/users/newuser`, newUser);
 
